import { Arrangement } from "./Arrangement";
import { Instrument } from "../instruments/Instrument";
import { Timeline } from "./Timeline";
import { ComposerSettings } from "../settings/ComposerSettings";

export class ComposerProject
{
  arrangements:Arrangement[] = [];
  instruments:Instrument[] = [];
  settings:ComposerSettings = new ComposerSettings();

  constructor()
  {
    let arrangment = new Arrangement();
    arrangment.timeline = new Timeline();

    arrangment.timeline.bpm   = 128;
    arrangment.timeline.start = 0;
    arrangment.timeline.end   = 4 * 4;

    this.arrangements.push( arrangment );
  }

}